export const PAID_RESTROOMS_FAQS = [
  {
    q: 'What are paid restrooms?',
    a: 'Paid restrooms are commercial restroom facilities where access requires a small fee — typically via tap-to-pay, card, or mobile wallet. Businesses use them to control non-customer traffic, reduce vandalism, and offset cleaning costs while keeping restrooms open.',
  },
  {
    q: 'Does Flush Locks charge my customers to use the restroom?',
    a: 'No. Your paying customers receive free access codes. Paid restroom access applies to walk-in traffic and non-customers who would otherwise use your restroom without buying anything.',
  },
  {
    q: 'How much does it cost a business to install paid restroom access?',
    a: 'Nothing upfront. Flush Locks covers hardware, installation, software, and ongoing support. Revenue from paid restroom access is shared with your business.',
  },
  {
    q: 'What types of businesses benefit from paid restrooms?',
    a: 'Restaurants, coffee shops, bars, convenience stores, entertainment venues, tourist attractions, and any high-traffic location where restroom misuse is a daily operational problem.',
  },
  {
    q: 'How is this different from old coin-operated restroom locks?',
    a: 'Flush Locks uses modern cashless payments — Apple Pay, tap-to-pay, and credit cards — plus remote monitoring, free customer codes, and a fully managed system. No coins, no attendants, no maintenance headaches.',
  },
  {
    q: 'Where is Flush Locks available today?',
    a: 'Flush Locks is actively piloting in the Denver metro area and expanding to select high-traffic markets. Apply through our pilot program to be considered for your location.',
  },
];
